import { accentColorConfig } from '@hooks/useAccentColor'
import { Agent } from '@typings/dify'
import { AccentColor } from '@typings/index'
import { Star } from 'lucide-react'

interface DraggableAgentProps {
  agent: Agent
  onSelect: (agent: Agent) => void
  onToggleFavorite: (agentId: string) => void
  isSelected: boolean
  isCollapsed?: boolean
  accentColor: AccentColor
}

const DraggableAgent = ({
  agent,
  onSelect,
  onToggleFavorite,
  isSelected,
  isCollapsed = false,
  accentColor,
}: DraggableAgentProps) => {
  return (
    <div
      className={`group mx-3 p-2 rounded-lg cursor-pointer transition-colors ${
        isSelected
          ? `${accentColorConfig[accentColor].light} dark:bg-gray-800`
          : `hover:${accentColorConfig[accentColor].lightHover} dark:hover:bg-gray-800`
      }`}
    >
      <div className="flex items-center space-x-3">
        <div
          onClick={() => onSelect(agent)}
          className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 cursor-pointer"
          style={{ backgroundColor: agent.color }}
        >
          <span className="text-white text-sm font-bold">
            {agent.translations.find(
              (translation) => translation.field === "label" && translation.language === localStorage.getItem('i18nextLng')?.toUpperCase()
            )?.value
            .replace('The ', '').replace('Le ', '').replace("L'", '').charAt(0)}
          </span>
        </div>

        {!isCollapsed && (
          <div className="flex-1 min-w-0" onClick={() => onSelect(agent)}>
            <div className="text-sm font-medium dark:text-white truncate">{
              agent.translations.find(
                (translation) => translation.field === "label" && translation.language === localStorage.getItem('i18nextLng')?.toUpperCase()
              )?.value
            }</div>
            <div className="text-xs text-gray-500 dark:text-gray-400 truncate">
              {agent.translations.find(
                (translation) => translation.field === "description" && translation.language === localStorage.getItem('i18nextLng')?.toUpperCase()
              )?.value}
            </div>
          </div>
        )}

        {!isCollapsed && (
          <button
            onClick={(e) => {
              e.stopPropagation()
              onToggleFavorite(agent.id.toString())
            }}
            className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <Star
              size={14}
              className={`${
                agent.isFavorite
                  ? 'fill-yellow-400 text-yellow-400'
                  : `text-gray-400 hover:${accentColorConfig[accentColor].text}`
              }`}
            />
          </button>
        )}
      </div>
    </div>
  )
}

export default DraggableAgent
